import React, { useState } from "react";
import { Router } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import history from "./Store/history/history";
import defaultRoutes from "./Routes/Routes";
import PrivateRoute from './Routes/PrivateRoutes';
//import ToastMessage from './Components/ToastMessage';
import { setStartLoader, setStopLoader } from './Store/action/loader';
import { getTheme, setTheme } from './Store/action/theme';
import { getUser, setUser } from './Store/action/user';
import { useEffect } from "react";
import { _theme, _user, _rawFetch, _list, _spendingControl } from "./Store/action/crud";
import * as constants from './Utils/constants';
import { isLogin, setToken } from "./Utils/token";
import { getTenantName, isHomeWidget } from "./Utils";
import { BASE_URL } from "./Utils/url";


let routes = defaultRoutes;
let tenantsName = constants.ENTITY_BRAND.MAZOOLA;

tenantsName = getTenantName();


function App(props) {
  const [appReady, setAppReady] = useState(false);
  const {
    toast,
  } = props
  const resolvePrivateRoutes = (routes) => {

    if (routes && Array.isArray(routes)) {
      return routes.map((route) => {

        if (route.isPrivate) {
          route.render = (props) => (
            <PrivateRoute component={route.component} {...props} />
          );
        }
        if (route.isAuth) {
          route.render = (props) => (
            <PrivateRoute component={route.component} {...props} />
          );

        }
        if (route.routes) {
          resolvePrivateRoutes(route.routes);
        }
        return route;
      });
    }
  };

  useEffect(() => {
    const tenant = localStorage.getItem("banno");
    if (tenant === "1") {
      setToken(localStorage.getItem("access_token"))
    }
    fetchTheme();
    if (isLogin()) {
      fetchUser();
    }

  }, []);// eslint-disable-line react-hooks/exhaustive-deps


  const fetchTheme = () => {

    const contrast = sessionStorage.getItem('contrast');
    if (contrast === "false") {
      sessionStorage.removeItem('contrast')
    }

    props._rawFetch(`${BASE_URL.CDN}/lists/branding.json`, null, response => {
      setTimeout(() => {
        setAppReady(true);
      }, 100);

    }, err => {
      setTimeout(() => {
        setAppReady(true);
      }, 100);
    })

    props._spendingControl(`/assets/configs/spendingcontrol.json`, null, response => {
      

    }, err => {
      
    })

  }

  const fetchUser = () => {
    if (isHomeWidget()) { return }
    props._user(constants.V6USERS, "", (res) => {

    })
  }

  if (!appReady) {
    return null; // or <Loader />
  }

  return (
    <>
      <Router history={history} basename={process.env.PUBLIC_URL}>
        {/* <ToastMessage toastData={toast && toast} /> */}

        {renderRoutes(resolvePrivateRoutes(routes))}

      </Router>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    toast: state.loader.toast,
    loaderStatus: state.loader.loaderStatus,
    tenantsName: tenantsName
  }
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    // showToastMessage,
    // resetToastMessage,
    setStartLoader,
    setStopLoader,
    getTheme,
    setTheme,
    setUser,
    getUser,
    _theme,
    _spendingControl,
    _user,
    _rawFetch,
    _list
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
